import { useState } from "react";
import classes from "./LoyaltyTrackerRow.module.css";

// Display-only mask: keep last 4 digits.
function maskPhone(phone) {
  // for time being as demo is going on simply pass without masking
  return phone;
  // later uncomment the following code
  // const str = String(phone ?? "");
  // if (str.length <= 4) return str;
  // return "*".repeat(str.length - 8) + str.slice(-4);
}

// Flatten attendance into rows. The refresh payload's customer object already
// carries points/totalVisits/lastVisitDate, so these display immediately
// without waiting for a per-row "Fetch" (accept) click.
function toRows(data) {
  const attendance = Array.isArray(data) ? data : [];
  return attendance.map((entry) => ({
    name: entry.customer?.name ?? "-",
    phone: entry.phone,
    grosspoints: entry.customer?.grosspoints,
    points: entry.visit?.points ?? entry.customer?.points,
    restaurantVisits: entry.visit?.totalVisits,
    lastVisitDate: entry.visit?.lastVisitDate,
  }));
}

// Show recency as "N days ago" rather than a raw date, so staff can scan
// how stale a customer's last visit is at a glance.
function daysSinceLastVisit(isoString) {
  if (!isoString) return null;
  const date = new Date(isoString);
  if (Number.isNaN(date.getTime())) return "-";
  const msPerDay = 24 * 60 * 60 * 1000;
  const diffDays = Math.floor((Date.now() - date.getTime()) / msPerDay);

  return diffDays;
}

function getOfferData(restaurantVisits,offerData, Day) {
    // console.log("offerData", offerData);
    // console.log("Day", Day);
    // console.log("restaurantVisits", restaurantVisits);
  if(restaurantVisits == 0)   return "New Customer";
  if (Day <= offerData.l1OfferValidity && Day > 0) {
    return offerData.l1Offer;
  }else if (Day > offerData.l1OfferValidity && Day <= offerData.l2OfferValidity) {
    return offerData.l2Offer;
  }else if (Day > offerData.l2OfferValidity) {
    return "No offer";
  }else if (Day <= 0) {
    return "No Offer";
  }
  else{
    return "--";
  }
}

export default function LoyaltyTrackerRow({ data, offerData, onAccept }) {
  const rows = toRows(data);
  
 
  //    console.log("data", data);
  const [busyPhone, setBusyPhone] = useState(null);
  // Extra per-customer info revealed by "Fetch", keyed by phone. Kept apart
  // from `rows` (derived from the `data` prop) so one row can be enriched
  // without the parent needing to refetch/replace the whole attendance list.
  const [details, setDetails] = useState({});
  // Per-row fetch error, keyed by phone, shown next to that row's button.
  const [fetchErrors, setFetchErrors] = useState({});

  async function handleAcceptClick(phone,name) {
    setBusyPhone(phone);
    setFetchErrors((prev) => ({ ...prev, [phone]: null }));
    try {
      const response = await onAccept(phone,name);
    //   console.log("response", response);
      // Page-level onAccept swallows network/HTTP errors and returns null;
      // treat a missing/failed response the same way here.
    //   if (!response || response.status !== "success") {
    //     setFetchErrors((prev) => ({
    //       ...prev,
    //       [phone]: "Could not fetch customer data",
    //     }));
    //     return;
    //   }
    //   const { customer,visit } = response.result ?? {};
    //   setDetails((prev) => ({
    //     ...prev,
    //     [phone]: {
    //       name: customer?.name,
    //       grosspoints: customer?.grosspoints,
    //       lastVisitDate: visit?.lastVisitDate,
    //       points: visit?.points,
    //       restaurantVisits: visit?.totalVisits,
    //     },
    //   }));
    } finally {
      setBusyPhone(null);
    }
  }

 

  return (
    <>
    
            {rows.map((row) => {
              const detail = details[row.phone];
              // Fetched name is the more authoritative value once available;
              // fall back to the name from the initial listing until then.
              const displayName = detail?.name ?? row.name;
              return (
                <tr key={row.phone}>
                  <td>{displayName}</td>
                  <td>{maskPhone(row.phone)}</td>
                  {/* <td>{detail?.grosspoints ?? row.grosspoints ?? "-"}</td> */}
                
                  <td>{detail?.restaurantVisits ?? row.restaurantVisits ?? "-"}</td>
                  <td>{detail?.points ?? row.points ?? "-"}</td>
                  <td>
                    {getOfferData(row.restaurantVisits,offerData, daysSinceLastVisit(detail?.lastVisitDate ?? row.lastVisitDate))}
                  </td>
                  <td>
                    <button
                       className={
                        row.restaurantVisits >= 0
                          ? classes.acceptButtonLightGreen
                          : classes.acceptButton
                      }
                      onClick={() => handleAcceptClick(row.phone,row.name)}
                      disabled={busyPhone === row.phone || row.restaurantVisits >= 0} 
                    >
                      {busyPhone === row.phone ? "Fetching..." : "Fetch"}
                    </button>
                    {fetchErrors[row.phone] && (
                      <div className={classes.rowError}>
                        {fetchErrors[row.phone]}
                      </div>
                    )}
                  </td>
                </tr>
              );
            })}
        
    </>
  );
}
